import invert from 'lodash/invert';
import { API_ROOT_URL, ROOM_TYPE_API } from '../../config/constant/apiConstant';
import api from '../../helpers/axiosHelper';
import { setRoomTypes } from '../../redux/slicers/appConfigSlicer';

export const GetRoomTypeApi = () => (dispatch) => {
  api()
    .root(API_ROOT_URL)
    .get(ROOM_TYPE_API)
    .success((data) => {
      dispatch(setRoomTypes(invert(data)));
    })
    .error((error) => {
      // TODO: add error handling after decision of the team
    })
    .send();
};
